import { CalculationEntityType } from '@commenda/api';

export const CalculationEntityTypeToText = {
  [CalculationEntityType.INVOICE]: 'Invoice',
  [CalculationEntityType.ESTIMATE]: 'Estimate',
};

export interface StatItem {
  label: string;
  value: number | string;
}

export interface StatsOverviewProps {
  items: StatItem[];
}
